import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthState, Current, DaanAuthentication } from 'src/app/states/auth.state';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UserService } from 'src/app/services/user.service';
import { DaanService } from 'src/app/services/daan.service';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { Store } from '@ngxs/store';

@Component({
	selector: 'app-daan',
	templateUrl: './daan.component.html',
	styleUrls: ['./daan.component.scss']
})
export class DaanComponent implements OnInit {
	user: any;
	payload: string;
	log = [];
	showLog = false;

	constructor(
		private store: Store,
		private userService: UserService,
		private spinner: SpinnerService,
		private route: ActivatedRoute,
		private sharedService: SharedService,
		private daanService: DaanService
	) {
		if (sharedService.isBrowser)
			AuthState.user$
				.pipe(takeUntil(this.unsubscribe$))
				.subscribe(user => {
					this.user = user;
					this.log.push({ log: 'update user', user });
				});
	}

	private unsubscribe$ = new Subject<void>();
	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}
	async ngOnInit() {
		if (!this.sharedService.isBrowser) return;

		this.log.push({ log: 'url', location })

		this.payload = this.route.snapshot.queryParams.payload;
		this.log.push({ log: 'get payload', payload: this.payload })
		if (this.payload) {
			await this.authenticate();
		}
	}


	private async authenticate() {
		this.spinner.show('loading');
		try {
			await this.store.dispatch(new DaanAuthentication(this.payload)).toPromise();
			await this.store.dispatch(Current).toPromise();

			if (this.user) {
				history.replaceState({}, document.title, '/daan');
			}
		} catch (error) {
			this.log.push({ log: 'authenticate error', error });
		}
		this.spinner.hide('loading');
	}
}
